export const removeProtocol = url => url.replace(/^https?:\/\//, '');